import { render, staticRenderFns } from "./CompaniesListPage.vue?vue&type=template&id=5016c95c&scoped=true&"
import script from "./CompaniesListPage.vue?vue&type=script&lang=js&"
export * from "./CompaniesListPage.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesListPage.vue?vue&type=style&index=0&id=5016c95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016c95c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VFlex,VLayout,VPagination,VSelect,VTextField})
